import type { ReactNode } from 'react';

// ONE GROUP OF THINGS, UNDER THE NAME OF WHAT THEY ARE.
//
// The name is the whole point. Eight buttons in one wrapping row have an order and no
// grouping: the line breaks where the viewport runs out, which is a different place on every
// screen and never where the subject changes. Named, a group cannot break in the wrong place.
//
// SMALL, GREY AND IN CAPITALS — a label for a group and not a heading in the panel. It stands
// between what is above it and what is below and must be legible without competing with
// either; capitals at ten pixels are read as a category, which is what this is.
//
// Shared, because the mesh modal says the same thing twice: the bands of controls under
// the viewer (see MeshControls) and the reference pictures over it (see CropStrip). Two copies
// of a label's type scale is where one of them quietly stops matching the other.
export function Band({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="flex w-full flex-col items-center gap-1">
      <span className="text-[10px] font-semibold uppercase tracking-[0.08em] text-slate-400">
        {title}
      </span>
      {/* Wrapping and centred, which is what a row of buttons wants. A child that lays itself
          out — a strip that scrolls rather than wraps — is one full-width item in it. */}
      <div className="flex w-full flex-wrap items-center justify-center gap-1.5">{children}</div>
    </div>
  );
}
